import { commodityList } from '@/api/domain/shop'
import { operateMaxShowLength } from '@/store/dict/config'
import { Popover, Image } from '@qs/ui' // 保留这个引入
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

const STATE_ENUM = {
  10: '上架',
  0: '下架',
  2: '待补齐信息',
}
export const ACTION_ENUM = {
  ADD: 1,
  EDIT: 2,
}

// 10网约车、20物流车、30其他--租赁商城2.X
export const OPERATION_TYPE_ENUM = {
  NETWORK: 10,
  LOGISTICS: 20,
  OTHER: 30,
}

export const OPERATION_TYPE_ENUM_CONFIG = {
  [OPERATION_TYPE_ENUM.NETWORK]: '网约车',
  [OPERATION_TYPE_ENUM.LOGISTICS]: '物流车',
  [OPERATION_TYPE_ENUM.OTHER]: '其他',
}

export const listConfig = ({
  loadUserList,
  setItemData,
  dealWithSearch,
  handleCustomerReset,
  handleViewDetail,
  getURL,
  judgePermission,
  handleShelf,
  handleTakeOff,
  handleEdit,
}) => {
  return {
    formData: {
      formProps: {
        model: {},
      },
      list: [
        {
          itemConfig: {
            prop: 'brandSeriesModel',
          },
          elConfig: {
            showModel: true,
            filterScene: CAR_MODEL_FILTER_SCENE.LEASE_PLAN,
          },
          render: 'CarBrandSeriesModel',
        },
        {
          el: 'select',
          itemConfig: {
            label: '门店信息',
            prop: 'storeId',
          },
          elConfig: {
            options: {
              label: 'name',
              value: 'id',
              list: [],
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '操作人',
            prop: 'operatorId',
          },
          elConfig: {
            remote: true,
            'reserve-keyword': true,
            placeholder: '请输入',
            'remote-method': loadUserList,
            options: {
              label: 'userName',
              value: 'id',
              list: [],
            },
          },
        },
        {
          el: 'input',
          itemConfig: {
            label: '商品名称',
            prop: 'name',
          },
          elConfig: {
            maxlength: 20,
            clearable: true,
            events: {
              input: (val) => {
                setItemData({ elConfigKey: 'value', key: 'name', data: val })
              },
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '商品上架状态',
            prop: 'state',
          },
          elConfig: {
            options: {
              label: 'name',
              value: 'code',
              list: [
                {
                  name: '全部',
                  code: '',
                },
                {
                  name: '上架',
                  code: '10',
                },
                {
                  name: '下架',
                  code: '0',
                },
                {
                  name: '待补齐信息',
                  code: '2',
                },
              ],
            },
          },
        },

      ],
      dealWithSearch,
      customizeReset: handleCustomerReset, // 自定义重置回调
      exportData: {
        exportTemplate: 'Commodity',
        filename: '商品库.xlsx',
        permissionName: 'car_to_rent_list_export',
      },
    },
    isShowDepartment: false,
    tableData: {
      columns: [
        {
          name: 'id',
          columnProps: {
            label: '商品ID',
            prop: 'id',
            width: 110,
          },
          render: ({ row }) => {
            if (!row.id) return '--'
            if (!judgePermission('car_rent_scheme_detail')) return row.id
            return <span class="a-hover-link" onClick={() => handleViewDetail(row)}>{row.id}</span>
          },
        },
        {
          name: 'name',
          columnProps: {
            label: '商品名称',
            prop: 'name',
            width: 160,
          },
        },
        {
          name: 'thumbnailUrl',
          columnProps: {
            label: '  商品图片',
            prop: 'thumbnailUrl',
            width: 110,
          },
          render: ({ row }) => {
            const _src = getURL({ data: row.thumbnailUrl, defaultImg: '' })
            if (!row.thumbnailUrl || !_src) {
              return '--'
            }
            return <Image src={_src} preview-src-list={[_src]} style="width: 80px; height: 80px;" fit="contain" />
          },
        },
        {
          name: 'brandName',
          columnProps: {
            label: '品牌',
            prop: 'brand',
          },
        },
        {
          name: 'carSeriesName',
          columnProps: {
            label: '车系',
            prop: 'carSeries',
          },
        },
        {
          name: 'rentPlans',
          columnProps: {
            label: '上架的租赁方案',
            prop: 'rentPlans',
            width: 150,
          },
          // 修改 rentPlans 的 render 方法
          render: ({ row }) => {
            if (!row.rentPlans?.length) return '--'

            return (
              <Popover // 使用引入的 Popover 组件
                placement="top"
                width="300"
                trigger="hover"
              >
                <div>
                  {row.rentPlans.map((item, index) => (
                    <p key={index}>
                      <span>{item.name}</span>
                    </p>
                  ))}
                </div>
                <div slot="reference">
                  {row.rentPlans.map((item, index) => {
                    if (index < 3) {
                      return <p key={index}><span>{item.name}</span></p>
                    }
                    if (index === 3) {
                      return <p key={index}>...</p>
                    }
                    return null
                  })}
                </div>
              </Popover>
            )
          },
        },
        {
          name: 'stores',
          columnProps: {
            label: '绑定的门店',
            prop: 'stores',
            width: 160,
          },
          render: ({ row }) => {
            if (!row.stores?.length) return '--'

            return (
              <el-popover
                placement="top"
                width="300"
                trigger="hover"
              >
                <div>
                  {row.stores.map((item, index) => (
                    <p key={index}>
                      <span>{item.name}</span>
                    </p>
                  ))}
                </div>
                <div slot="reference">
                  {row.stores.map((item, index) => {
                    if (index < 3) {
                      return <p key={index}><span>{item.name}</span></p>
                    }
                    if (index === 3) {
                      return <p key={index}>...</p>
                    }
                    return null
                  })}
                </div>
              </el-popover>
            )
          },
        },
        {
          name: 'state',
          columnProps: {
            label: '商品上架状态',
            prop: 'state',
            width: 120,
          },
          // eslint-disable-next-line no-nested-ternary
          getText: ({ row }) => STATE_ENUM[row.state] || '',
        },
        {
          name: 'operatorName',
          columnProps: {
            label: '操作人',
            prop: 'operatorName',
          },
        },
        {
          name: 'createUser',
          columnProps: {
            label: '创建人',
            prop: 'createUser',
          },
        },
        {
          name: 'gmtCreate',
          columnProps: {
            label: '创建时间',
            prop: 'gmtCreate',
            width: 160,
          },
        },
        {
          name: 'gmtModified',
          columnProps: {
            label: '更新时间',
            prop: 'gmtModified',
            width: 155,
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            fixed: 'right',
            width: 240,
          },
          maxShowLength: operateMaxShowLength,
          type: 'operate',
          getOperateList: ({ row }) => {
            const btn = [
              { name: 'shelf', label: '上架', permission: row.state === 0, action: () => handleShelf(row) },
              { name: 'takeOff', label: '下架', permission: row.state === 10, action: () => handleTakeOff(row) },
              { name: 'edit', label: '编辑', permission: row.state === 0 || row.state === 2, action: () => handleEdit(row) },
            ]
            return btn.filter((item) => item.permission)
          },
        },
      ],
      apiFn: commodityList,
    },
  }
}
